import useQueryParam from '@jwp/ott-ui-react/src/hooks/useQueryParam';
import { useNavigate } from 'react-router-dom';
import Home from '@jwp/ott-ui-react/src/pages/Home/Home';
import ValidateQRLogin from '@jwp/ott-ui-react/src/containers/AccountModal/forms/ValidateQRLogin';
import Dialog from '@jwp/ott-ui-react/src/components/Dialog/Dialog';
import useEventCallback from '@jwp/ott-hooks-react/src/useEventCallback';

const ActivateTV = () => {
  const message = useQueryParam('message');
  const navigate = useNavigate();
  const ValidateQRLogincloseHandler = useEventCallback(() => {
    localStorage.removeItem('otpVerification');
    navigate('/');
  });

  return (
    <>
      <Home />
      <Dialog size="small" open={true} onClose={ValidateQRLogincloseHandler} role="dialog">
        <ValidateQRLogin messageKey={message} />
      </Dialog>
    </>
  );
};

export default ActivateTV;
